module.exports = __webpack_public_path__ + "static/media/user-icon-2.b76010b7.png";